import React, { Fragment } from 'react';
import { DataSourceIcon } from '@/pages/home/pages/home/components/DataSource';
import { METRIC_NAME } from './_config/metricName';
import { useIntl, history } from 'umi';
import { datamapIntelligenceMetricsPath } from '@/pages/home/utils/urlConfig';

const clickLearnMore = (metric:string, metricKey = '', entityType = '')=>{  
  history.push({
    pathname: datamapIntelligenceMetricsPath,
    query: {
      pageid: metric === 'newzoo' ? 'ogdb' : metric,
      metric: metricKey || '',
      gameType: entityType || ''
    },
  });
}
export type DataSourceMetricType =
  | 'appannie'
  | 'appstore'
  | 'bilibili'
  | 'crunchbase'
  | 'databarin'
  | 'epic'
  | 'fbgaming'
  | 'googleplay'
  | 'hatchet'
  | 'mscience'
  | 'newzoo'
  | 'nintendo'
  | 'npd'
  | 'playstation'
  | 'sensortower'
  | 'steam'
  | 'taptap'
  | 'twitch'
  | 'xbox'
  | 'youtube';
interface PropsType {
  metric: DataSourceMetricType;
  sourceNameLocalId: string;
  metricKey?: string;
  entityType?: string
}
export const DataSourceBubbleContent = (props: PropsType) => {
  const { formatMessage } = useIntl() // 中英切换方法
  const { metric, sourceNameLocalId, metricKey = '', entityType = ''} = props;
  return (
    <span>
      {formatMessage({
        id: metric === 'newzoo' ? 'dbi_metric_dataof_generatedby' : 'dbh_metric_dataof_comesfrom',
      }, {
        sourceName: sourceNameLocalId
      })}
      {/* Data of {sourceName} comes from &nbsp; */}
      <DataSourceIcon className='datasource-comp-sourcessicon' type={metric} />
      {METRIC_NAME[metric]}
      {metric === 'newzoo' ? formatMessage({ id: 'dbi_metric_dataof_generatedby_suf' }) : ''}
      
      <span
        style={{ color: '#0076FF', paddingLeft: '5px', cursor: 'pointer' }}
        onClick={() => {
          clickLearnMore(metric, metricKey, entityType);
        }}
      >{formatMessage({ id: 'dbh_learnmore', })}</span>
    </span>
  )
}

export const RankingDataBubbleContent = (props: any) => {
  const { metric, sourceNameLocalId } = props;
  const { formatMessage } = useIntl() // 中英切换方法
  const getTransLanguage = () => {
    const t = formatMessage({
      id: 'dbh_metric_rankingdata_of',
    }, {
      sourceName: sourceNameLocalId,
    });
    const str = t.split(' ');
    if (Array.isArray(str)) {
      const node = str.map((item, index) => {
        return (
          <Fragment key={index}>
            {item === 'icon' ?
              <DataSourceIcon className='datasource-comp-sourcessicon' type={metric} /> :
              (item + ' ')}
          </Fragment>
        )
      })
      return node;
    }
    return t;
  }
  return (
    <span>
      {getTransLanguage()}
      <DataSourceIcon className='datasource-comp-sourcessicon' type={metric} />
      {METRIC_NAME[metric]}.

      <span
        style={{ color: '#0076FF', paddingLeft: '5px', cursor: 'pointer' }}
        onClick={() => {
          clickLearnMore(metric);
        }}
      >{formatMessage({ id: 'dbh_learnmore', })}</span>
    </span>
  )
}

export const DatabrainBubbleContent = (props: any) => {
  const { metric, sourceNameLocalId, metricKey = '', entityType = '' } = props;
  const { formatMessage } = useIntl() // 中英切换方法
  return (
    <span>
      {formatMessage({
        id: 'dbh_metric_dataof_comesfrom',
      }, {
        sourceName: sourceNameLocalId
      })}
      {/* Data of {sourceName} comes from &nbsp; */}
      <DataSourceIcon className='datasource-comp-sourcessicon' type={metric} />
      {/* Calibrated Data(DataBrain校准数据).  */}
      {formatMessage({ id: 'dbh_metric_calibrated_data', })}.
      <br />
      <span> {formatMessage({ id: 'dbh_metric_databrain_text_desc', })}</span>
      <span
        style={{ color: '#0076FF', paddingLeft: '5px', cursor: 'pointer' }}
        onClick={() => {
          clickLearnMore('databarin', metricKey, entityType);
        }}
      >{formatMessage({ id: 'dbh_learnmore', })}</span>
    </span>
  )
}
//自定义DAU—databrain
export const TableDatabrainBubbleContent = (props: any) => {
  const { formatMessage } = useIntl() // 中英切换方法
  return (
    <span>
      <span><DataSourceIcon className='datasource-comp-sourcessicon' type={'databarin'} />
        {/* DataBrain Calibrated Data (DataBrain校准数据) Click the game name to see details. */}
        {formatMessage({ id: 'dbh_metric_dataBrain_calibrated_details', })}
      </span>
      <br />
      <span> {formatMessage({ id: 'dbh_metric_databrain_text_desc', })}</span>
      <span
        style={{ color: '#0076FF', paddingLeft: '5px', cursor: 'pointer' }}
        onClick={() => {
          clickLearnMore('databarin');
        }}
      >{formatMessage({ id: 'dbh_learnmore', })}</span>
    </span>
  )
}